import { render } from "./Residual.vue?vue&type=template&id=13e40217&scoped=true&ts=true"
import script from "./Residual.ts?vue&type=script&lang=ts"
export * from "./Residual.ts?vue&type=script&lang=ts"

import "./Residual.scss?vue&type=style&index=0&id=13e40217&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e40217"]])

export default __exports__